import styled from "styled-components";
import { borderColorDADADA, fontColor, inlineWidth, loginChangeWidth, primaryColor } from "../../styles/theme";
import { Link } from "react-router-dom";

interface LayoutProps {
  paddingTop?: string;
  bgImg?: string;
}
const LoginLayout = styled.div<LayoutProps>`
  width: 100%;
  height: 82vh;
  background-image: url(${(props) => props.bgImg});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  margin: 0px auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media only screen and (max-width: ${inlineWidth}) {
    width: 100%;
    padding-left: 12px;
    padding-right: 12px;
  }
  @media only screen and (max-width: ${loginChangeWidth}) {
    background-image: none;
    justify-content: flex-start;
  }
`;

const LoginBox = styled.div`
  background: #fff;
  border: 1px solid #ddd;
  padding: 2rem;
  margin: 0px auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 500px;
  @media only screen and (max-width: ${loginChangeWidth}) {
    border-width: 0px;
    width: 100%;
    padding: calc(1rem + 1vw);
  }
`;

const FontLink = styled.div`
  font-size: calc(0.7rem + 0.2vw);
  color: #555555;
  cursor: pointer;
  :hover {
    color: ${fontColor};
  }
`;

const IntegratedRegistLink = styled(Link)`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  box-sizing: border-box;
  font-size: calc(0.7rem + 0.2vw);
  cursor: pointer;
  text-align: center;
`;

interface IntegratedFontProps {
  fontSize?: string;
  color?: string;
  fontWeight?: string;
}

const IntegratedFont = styled.div<IntegratedFontProps>`
  font-weight: ${(props) => props.fontWeight};
  font-size: ${(props) => props.fontSize};
  color: ${(props) => props.color};
  cursor: pointer;
  text-align: center;
  color: #222222;
`;
export { LoginLayout, LoginBox, FontLink, IntegratedRegistLink, IntegratedFont };
